module.exports = __webpack_public_path__ + "BDMimon.jpg?bfd0703b5cd3ef772236c9a8623be5a2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/BDMimon.jpg
// module id = 247
// module chunks = 0